import React from "react";
import moment from "moment";
import { Popover, OverlayTrigger, Row, Col } from "react-bootstrap";
import "./popupContent.css";

const PopupContent = React.forwardRef((props, ref) => {
  //console.log("PopupContent props...",props)
  let sortedArr = props.data.sort((a, b) => {
    if (moment(a.timestamp).isBefore(moment(b.timestamp))) return 1;
    if (moment(a.timestamp).isAfter(moment(b.timestamp))) return -1;
    return 0;
  });

  let gridRows = sortedArr.map((obj, index) => {
    let description = [];

    if (obj.description !== undefined && obj.description !== "") {
      description.push(
        <span key={`${obj.type}_description_${obj.timestamp}_${index}`}>
          {obj.description}
        </span>
      );
    }

    return (
      <Row
        style={{ verticalAlign: "middle", margin: "10px 0px" }}
        key={`${props.type}_${index}_${props.date}`}
      >
        <Col
          xs={12}
          sm={6}
          md={2}
          style={{
            verticalAlign: "middle",
            textAlign: "center",
          }}
        >
          <img
            src={"/images/diary/" + props.type + "_card_icon.png"}
            alt={`${props.type}_card_icon_alt`}
            style={{
              width: "20px",
              paddingTop: "15px",
            }}
          />
        </Col>
        <Col xs={12} sm={6} md={10} style={{ verticalAlign: "middle" }}>
          <Row style={{ fontSize: "10px" }}>
            <Col xs={12} sm={12} md={12} style={{ textAlign: "left" }}>
              <span style={{ float: "left" }}>
                {moment.unix(obj.timestamp / 1000).format("MMM DD")}
              </span>
              <span style={{ float: "right" }}>
                {moment.unix(obj.timestamp / 1000).format("hh:mm A")}
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <div
                style={{
                  paddingTop: "5px",
                  fontSize: "11px",
                }}
              >
                <span
                  style={{ fontWeight: "bold", textTransform: "uppercase" }}
                >
                  {obj.type}
                </span>
                <div style={{ fontSize: "11px" , textTransform: "capitalize"}}>
                  {description ? description : ""}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  });
  let gridStyle = {};
  if (props.type === "weightlogs") {
    gridStyle = {
      maxHeight: "400px",
      minWidth: "230px",
      overflow: "auto",
      padding: "0px",
      margin: "1em",
    };
  } else {
    gridStyle = {
      cursor: "pointer",
      maxHeight: "700px",
      minWidth: "230px",
      overflow: "auto",
      padding: "0px",
      margin: "1em",
    };
  }

  return (
    <Popover id="popover-basic" ref={ref} {...props} show={props.show}>
      {/* <Popover.Header as="h3" style={{textTransform: "capitalize"}}>{props.type}</Popover.Header> */}
      <Popover.Body style={gridStyle} onClick={() => props.showDetails()}>
        {gridRows}
      </Popover.Body>
    </Popover>
  );
});

export default PopupContent;
